<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      data:{}
    };
  },
  methods: {
    exportDatabase(){
        this.http.download("export-database",`export-database.sql`,)
    }
  },
  computed: {
 
  },
  created() {
    
  },
  mounted() {
   
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.organization.subItems.export')"
    />
    <div class="card">
      <div class="card-body">
        <div class="row">
            <div class="col-4">
                <button
                @click="exportDatabase()"
                    type="button"
                    name=""
                    id=""
                    class="btn btn-primary"
                >
                    {{$t('menu.menuitems.organization.subItems.export')}}
                </button>
            </div>
            
        </div>

        
      </div>
    </div>
    <!-- end  table -->

    <!-- start show roles modal -->
    
    <!--end-->
  </Layout>
</template>
